import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "esports_call_of_duty_mobile_c2307",
  "use": "esports_call_of_duty_mobile_c2307-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" viewBox=\"0 0 24 24\" id=\"esports_call_of_duty_mobile_c2307\">\n    <path d=\"M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12z\" fill=\"#020203\" />\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.45 18.975l-1.5-1.2V6.15l1.5-1.2 2.25 1.5v10.725l-2.25 1.8zm7.95-11.85L12 8.7 9.6 7.05v7.2l2.325 1.425h.15L14.4 14.25V7.125zm3.15 11.85l1.5-1.2V6.15l-1.5-1.2-2.25 1.5v10.725l2.25 1.8z\" fill=\"#FDC60D\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol